/* @flow */

import { combineReducers } from 'redux';
import Immutable from 'immutable';
import type { Map } from 'immutable';
import type { State } from './index';
import type { Action } from 'bucket/actions/folders';

export type FoldersState = {
  items: Map<number, BucketFolder>,
  isFetching: boolean,
  isSaving: boolean,
  isUpdating: boolean,
  isRemoving: boolean,
};

const folders = (
  state: Map<number, BucketFolder> = Immutable.Map(),
  action: Action
) => {
  switch (action.type) {
    case 'FETCH_FOLDERS_SUCCESS':
    case 'SAVE_FOLDER_SUCCESS':
    case 'UPDATE_FOLDER_SUCCESS':
      return state.merge(Immutable.Map(action.response.entities.folders));
    case 'REMOVE_FOLDER_SUCCESS':
      return state.remove(action.folderId.toString());
    default:
      return state;
  }
};

const isFetching = (state: boolean = false, action: Action) => {
  switch (action.type) {
    case 'FETCH_FOLDERS':
      return true;
    case 'FETCH_FOLDERS_FAILURE':
    case 'FETCH_FOLDERS_SUCCESS':
      return false;
    default:
      return state;
  }
};

const isSaving = (state: boolean = false, action: Action) => {
  switch (action.type) {
    case 'SAVE_FOLDER':
      return true;
    case 'SAVE_FOLDER_SUCCESS':
      return false;
    default:
      return state;
  }
};

const isUpdating = (state: boolean = false, action: Action) => {
  switch (action.type) {
    case 'UPDATE_FOLDER':
      return true;
    case 'UPDATE_FOLDER_SUCCESS':
      return false;
    default:
      return state;
  }
};

const isRemoving = (state: boolean = false, action: Action) => {
  switch (action.type) {
    case 'REMOVE_FOLDER':
      return true;
    case 'REMOVE_FOLDER_SUCCESS':
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  items: folders,
  isFetching,
  isSaving,
  isUpdating,
  isRemoving,
});

export const getAllFolders = (state: State): List<BucketFolder> =>
  state.folders.items.toList().sortBy(f => f.name);
export const getFolderById = (state: State, id: number): ?BucketFolder =>
  state.folders.items.get(id);

export const getIsFetching = (state: State): boolean =>
  state.folders.isFetching;
export const getIsSaving = (state: State): boolean => state.folders.isSaving;
export const getIsUpdating = (state: State): boolean =>
  state.folders.isUpdating;
export const getIsRemoving = (state: State): boolean =>
  state.folders.isRemoving;



// WEBPACK FOOTER //
// ./src/modules/bucket/reducers/folders.js